export default {
  user: JSON.parse(window.localStorage.getItem('user')) || false,
  city: JSON.parse(window.localStorage.getItem('city')) || false,
  mktp_rent: JSON.parse(window.localStorage.getItem('mktp_rent')) || false
}



// WEBPACK FOOTER //
// ./src/store/state.js